export default {
    binCell: {
        ariaLabel: 'Interval {index}, {start} do {end}, vrijednost {value} MWh',
    },
}
